import client from "@/utils/api/client";
import { ListItemResponse, ListResponse } from "@/web-client/api";
import useMasonry from "@/hooks/useMasonry";

import usePagination from "@/hooks/usePagination";
import { Dispatch, FC, SetStateAction, useCallback } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import ErrorView from "@/components/ErrorView";
import MasonryList from "@/components/MasonryList";
import { ModalEditListPhase } from "./ModalEditList";
import Circular from "@/components/Circular";

type Props = {
  list: ListResponse;
  move: Dispatch<SetStateAction<ModalEditListPhase>>;
  onSelected?: (listItem: ListItemResponse) => void;
  scrollableTargetId?: string;
};

const EditSelectCoverForListTemplate: FC<Props> = ({
  list,
  move,
  onSelected,
  scrollableTargetId,
}): JSX.Element => {
  const { data, dataLength, next, hasNext, notFound } =
    usePagination<ListItemResponse>(
      `/lists/${list.id}/items`,
      20,
      async ({ limit, cursor }) => {
        const { data } = await client.listsIdItemsGet({
          id: list.id,
          limit,
          cursor: cursor as number,
        });

        return data;
      },
      { waitForAuth: true },
    );

  const { items, numberOfColumns, containerRef, gap } = useMasonry(data, 16, 2);

  const clickImageHandler = useCallback(
    (listItem: ListItemResponse) => {
      move(ModalEditListPhase.Edit);

      if (onSelected) onSelected(listItem);
    },
    [move, onSelected],
  );

  return (
    <div className="space-y-24 relative">
      <header className="flex space-x-12">
        <div className="flex-1">
          <button onClick={() => move(ModalEditListPhase.Edit)}>戻る</button>
        </div>
        <h1 className="flex-[2] font-bold text-center">カバーイメージを選択</h1>
        <div className="flex-1"></div>
      </header>

      <InfiniteScroll
        style={{ overflow: "visible" }}
        dataLength={dataLength}
        hasMore={hasNext}
        next={next}
        loader={<Circular />}
        scrollableTarget={scrollableTargetId}
      >
        <MasonryList<ListItemResponse>
          containerRef={containerRef}
          organizedItems={items}
          columnNumber={numberOfColumns}
          onRender={(listItem: ListItemResponse) => {
            return (
              <button
                key={listItem.id}
                onClick={() => clickImageHandler(listItem)}
                className="hover:brightness-75"
              >
                <img src={listItem.upload_image.urls.small} />
              </button>
            );
          }}
          gap={gap}
        />
      </InfiniteScroll>

      {notFound && <ErrorView>リストのアイテムがありません</ErrorView>}
    </div>
  );
};
export default EditSelectCoverForListTemplate;
